import {
  mdiAccountAlert,
  mdiAccountGroup,
  mdiAccountReactivate,
  mdiAlert,
  mdiAtomVariant,
  mdiHexagonSlice5,
  mdiHomeOutline,
  mdiSchool,
} from '@mdi/js'

export default [
  {
    title: 'Home',
    icon: mdiHomeOutline,
    to: 'home',
  },
  {
    title: 'Users List',
    icon: mdiAccountGroup,
    to: 'user-information',
  },
  {
    title: 'Incidents',
    icon: mdiAlert,
    children: [
      {
        title: 'Incident List',
        to: 'incident-list',
      },
      {
        title: 'Incident Details',
        to: { name: 'incident-detail', params: { id: 1 } },
      },
    ],
  },
  {
    title: 'User Incidents',
    icon: mdiAccountAlert,
    children: [
      {
        title: 'User Incident List',
        to: 'user-incident-list',
      },
      {
        title: 'User Incident Details',
        to: { name: 'user-incident-detail', params: { id: 1 } },
      },
    ],
  },
  // {
  //   title: 'Achievements',
  //   icon: mdiPoliceBadge,
  //   to: 'second-page',
  // },
  {
    title: 'Risk Profile',
    icon: mdiHexagonSlice5,
    to: 'third-page',
  },
  {
    title: 'Trainings',
    icon: mdiSchool,
    to: 'trainings',
  },
  {
    title: 'Trends',
    icon: mdiAccountReactivate,
    to: 'trends',
  },
  {
    title: 'Oracle',
    icon: mdiAtomVariant,
    children: [
      {
        title: 'Summaries',
        to: 'oracle',
      },
    ],
  },
]
